import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './TemplatesTypes.css';

const brokerageTemplates = [
    { id: 'brokerage-base', title: 'Base', description: 'Solid foundation with essential features and clean design.', img: require('../../assets/imgs/previews/brokerage/base.jpg') },
    { id: 'brokerage-luxury', title: 'Luxury', description: 'Elegant and sophisticated, ideal for high-end clients.', img: require('../../assets/imgs/previews/brokerage/luxury.jpg') },
    { id: 'brokerage-metropolitan', title: 'Metropolitan', description: 'Modern visuals with neutral tones and polish.', img: require('../../assets/imgs/previews/brokerage/metropolitan.jpg') },
    { id: 'brokerage-skyline', title: 'Skyline', description: 'Highlights condo living and cityscapes.', img: require('../../assets/imgs/previews/brokerage/skyline.jpg') },
    { id: 'brokerage-vibrance', title: 'Vibrance', description: 'Energetic and bold with asymmetrical design.', img: require('../../assets/imgs/previews/brokerage/vibrance.jpg') },
    { id: 'brokerage-futuristic', title: 'Futuristic', description: 'Neon and high-tech aesthetics for modern appeal.', img: require('../../assets/imgs/previews/brokerage/futuristic.jpg') },
];

const BrokerageTemplates = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOrder, setSortOrder] = useState('az');

    let filteredTemplates = brokerageTemplates.filter(template =>
        template.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        template.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (sortOrder === 'az') {
        filteredTemplates = filteredTemplates.sort((a, b) => a.title.localeCompare(b.title));
    } else if (sortOrder === 'za') {
        filteredTemplates = filteredTemplates.sort((a, b) => b.title.localeCompare(a.title));
    }

    return (
        <>
            <Helmet>
                <title>Brokerage Website Templates | AptoWebsites</title>
                <meta name="description" content="Browse professional website templates for real estate brokerages. Team pages, listings, and branding options included." />
                <meta name="keywords" content="brokerage website templates, real estate brokerage, team websites, AptoWebsites" />
                <meta property="og:title" content="Brokerage Website Templates | AptoWebsites" />
                <meta property="og:description" content="Browse professional website templates for real estate brokerages. Team pages, listings, and branding options included." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/brokerage-templates" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/brokerage-templates" />
            </Helmet>
            <div className="templatebackground">
                <div className="template-header-bar professional">
                    <div className="template-header-titles">
                        <h1 className="template-header-title">Brokerage Website Templates</h1>
                    </div>
                    <div className="template-header-controls">
                        <div className="template-sort-group">
                            <label htmlFor="template-sort" className="template-sort-label">Sort:</label>
                            <select
                                id="template-sort"
                                className="template-sort-select"
                                value={sortOrder}
                                onChange={e => setSortOrder(e.target.value)}
                            >
                                <option value="az">A-Z</option>
                                <option value="za">Z-A</option>
                            </select>
                        </div>
                        <div className="template-search-group">
                            <svg className="search-icon" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                <circle cx="9" cy="9" r="7" stroke="#0d47a1" strokeWidth="2"/>
                                <line x1="14.4142" y1="14" x2="18" y2="17.5858" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <input
                                type="text"
                                placeholder="Search templates..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="filter-input template-search-input"
                            />
                        </div>
                    </div>
                </div>
                <div className="template-section">
                    <div className="template-list">
                        {filteredTemplates.map(template => {
                            let mobileImgSrc;
                            try {
                                mobileImgSrc = require(`../../assets/imgs/previews/mobile/brokerage/${template.id.replace('brokerage-', '')}.jpg`);
                            } catch (e) {
                                mobileImgSrc = template.img;
                            }
                            return (
                                <Link to={`/${template.id}`} key={template.id} className="template-box">
                                    <div className="template-img-wrapper overlap">
                                        <img src={template.img} alt={template.title} className="template-img main-img" />
                                        <div className="phone-mockup-container overlap">
                                            <img
                                                src={require('../../assets/imgs/mockups/phone-mockup-transparent.png')}
                                                alt="Phone Mockup"
                                                className="phone-mockup-img"
                                            />
                                            <img
                                                src={mobileImgSrc}
                                                alt={`${template.title} mobile`}
                                                className="template-img phone-inside-img"
                                            />
                                        </div>
                                    </div>
                                    <div className="template-info">
                                        <h3>{template.title}</h3>
                                        <p>{template.description}</p>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default BrokerageTemplates;
